import { formatReferenceCopy } from 'utils/typography'
import {
  useTranslation,
} from 'react-i18next'
import {
  Box,
  Stack,
  Typography,
} from '@mui/material'

import FullSupplyCostReceiptAmounts from './full-supply-cost-receipt-amounts'

const ProposalServicesTotalSummary = ({
  comparison,
  currencyCode,
  variant = 'default',
}: ApplicationProposalServicesTotalSummaryProps) => {
  const { t } = useTranslation()

  const isEditorTotal = variant === 'in-card-body'

  if (!comparison?.after?.trim() && !comparison?.before?.trim()) return null

  return (
    <Stack
      direction={isEditorTotal ? 'row' : 'column'}
      spacing={isEditorTotal ? 2 : 0.5}
      alignItems={isEditorTotal ? 'center' : 'flex-end'}
      justifyContent={isEditorTotal ? 'space-between' : undefined}
      sx={{
        flexWrap: isEditorTotal ? 'wrap' : undefined,
        rowGap: isEditorTotal ? 0.5 : undefined,
      }}
    >
      {isEditorTotal && (
        <Typography variant='body2' component='p' color='text.primary'>
          {formatReferenceCopy(t('applications__text__proposalHeaderServicesTotal'))}
        </Typography>
      )}
      <Box sx={{
        typography: isEditorTotal ? 'h6' : 'h5',
      }}>
        <FullSupplyCostReceiptAmounts
          comparison={comparison}
          currencyCode={currencyCode}
        />
      </Box>
    </Stack>
  )
}

export default ProposalServicesTotalSummary
